﻿import jquery from 'jquery';


class FavoritosRepository {

    constructor(favoritesRepositoryDto) {

        this.__favoritesRepositoryDto = favoritesRepositoryDto;
        this.__removeFav = 'removeFav';
        this.__addFav = 'addAlInm';

       
    }

    setFavorito(favoritoUrl, favoritoData, type) {

        return new Promise((resolve, reject) => {
            if (type === "remove") {
                favoritoUrl = favoritoUrl.replace(this.__addFav, this.__removeFav);
                favoritoData = favoritoData.replace(this.__addFav, this.__removeFav);
            } else {
                favoritoUrl = favoritoUrl.replace(this.__removeFav, this.__addFav);
                favoritoData = favoritoData.replace(this.__removeFav, this.__addFav);
            }

            jquery.ajax({
                type: "POST",
                dataType: "json",
                url: favoritoUrl,
                data: favoritoData,
                success: (data) => {
                    resolve({ type, data: data.status });
                },
                error: (jqXHR, textStatus) => {
                    reject({ jqXHR, textStatus });
                }
            });

        });
    }

    saveRate(rateData) {

        return new Promise((resolve, reject) => {
            jquery.ajax({
                url: this.__favoritesRepositoryDto.UrlRateFav,
                type: 'POST',
                data: rateData,
                success: () => {
                    resolve();
                },
                error: (jqXHR, textStatus) => {
                    reject({ jqXHR, textStatus });
                }
            });
        });
    }

    saveComment(commentData) {
        return new Promise((resolve, reject) => {
            jquery.ajax({
                url: this.__favoritesRepositoryDto.UrlCommentFav,
                type: 'POST',
                data: commentData,
                success: () => {
                    resolve();
                },
                error: (jqXHR, textStatus) => {
                    reject({ jqXHR, textStatus });
                }
            });


        });
    }
}

export default FavoritosRepository;